import React from "react";

function PgStatusChip({ status, readyToComplete }) {
  if (readyToComplete) {
    return <span className="pg-chip pg-chip--complete">Ready to Complete</span>;
  }
  const map = {
    Assigned: "pg-chip--assigned",
    Idle: "pg-chip--unassigned",
    Suspended: "pg-chip--suspended",
  };
  const cls = map[status] || "pg-chip--unassigned";
  return <span className={`pg-chip ${cls}`}>{status}</span>;
}

export default PgStatusChip;
